// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2KnK7","footer":"ModalFilter_footer__38uZD"};